import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import CarInquiryForm from "./car";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CarInquiryForm />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
